import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/reports/ap-aging")({
  beforeLoad: () => {
    throw redirect({ to: "/reports/$reportId", params: { reportId: "498695f9-d47d-550e-8637-ec345f7b30c2" }, replace: true });
  },
  component: () => null,
});
